module.exports = __webpack_public_path__ + "img/ai-coming-soon.3e31c3d2.png";